/**
 * @author Rahul Nainala
 * @description A custom Antd Table based on Configuration 
 * @view odd even colors taken from Antd.
 */
import { Table } from "antd";
import { connect } from "react-redux";
import styled from "styled-components";

const StyledTable = styled(Table)`

  .ant-table-row:nth-child(even) {
    background-color: ${(props) => props.customTheme?.even} !important;
  }

  .ant-table-row:nth-child(odd) {
    background-color: ${(props) => props.customTheme?.odd} !important;  
  }

`;

const mapStateToProps = (state) => {
  return {
    customTheme: state.ThemeReducer.customComponent?.table
  };
};

export default connect(mapStateToProps)(StyledTable);
